import type { HTMLAttributes } from "react";
import { cx } from "./cx";

export type BadgeTone = "stock" | "low" | "out" | "info" | "genuine" | "machine" | "neutral";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** stock · low · out · info · genuine (gold seal) · machine (steel) · neutral */
  tone?: BadgeTone;
}

const TONE: Record<BadgeTone, string> = {
  stock: "bg-success-100 text-success-700 border-green-200",
  low: "bg-warning-100 text-warning-700 border-gold-300",
  out: "bg-danger-100 text-danger-700 border-[#e8cdc8]",
  info: "bg-info-100 text-info-700 border-blue-200",
  genuine: "bg-gold-100 text-gold-800 border-gold-300",
  neutral: "bg-paper-2 text-ink-600 border-paper-3",
  machine: "bg-steel-200 text-steel-700 border-steel-300",
};

/** Status pill. Colour plus a word — status is never carried by colour alone. */
export function Badge({ tone = "neutral", className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cx(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-[3px]",
        "type-eyebrow [font-size:var(--text-2xs)] tracking-[var(--tracking-wider)] uppercase",
        TONE[tone],
        className,
      )}
      {...rest}
    >
      {/* one flex item: a bare text node beside an interpolation would take the gap */}
      <span>{children}</span>
    </span>
  );
}
